import { useState } from 'react';
import { CopyToClipboard } from '../../custom-components/CopyToClipboard';
import { EmailFormatSlideout } from '../../custom-components/EmailFormatSlideout';
import { EmailTypeSlideout } from '../../custom-components/EmailTypeSlideout';
import { EmailVerificationSlideout } from '../../custom-components/EmailVerificationSlideout';
import UniversalTag from '../../custom-components/UniversalTag';
import './EmailDetail.scss';

interface EmailDetailProps {
  email: string;
  emailType?: string | null;
  emailFormat?: string | null;
  emailSource?: string | null;
  emailVerificationStatus?: string | null;
  emailVerifiedAt?: string | null;
}

export function EmailDetail({
  email,
  emailType,
  emailFormat,
  emailSource,
  emailVerificationStatus,
}: EmailDetailProps) {
  const [isSlideoutOpen, setIsSlideoutOpen] = useState(false);
  const [isTypeSlideoutOpen, setIsTypeSlideoutOpen] = useState(false);
  const [isFormatSlideoutOpen, setIsFormatSlideoutOpen] = useState(false);

  return (
    <div className="email-detail">
      <CopyToClipboard value={email} title="Copy email" />
      <span className="email-detail__value">{email}</span>
      {emailVerificationStatus && (
        <UniversalTag
          category={emailVerificationStatus}
          onClick={() => setIsSlideoutOpen(true)}
        />
      )}
      {emailType && (
        <UniversalTag
          category={emailType}
          onClick={() => setIsTypeSlideoutOpen(true)}
        />
      )}
      {emailFormat && (
        <UniversalTag
          category={emailFormat}
          onClick={() => setIsFormatSlideoutOpen(true)}
        />
      )}
      {emailSource && emailSource !== 'OBSERVED' && <UniversalTag category={emailSource} />}

      <EmailVerificationSlideout
        isOpen={isSlideoutOpen}
        onClose={() => setIsSlideoutOpen(false)}
      />
      <EmailTypeSlideout
        isOpen={isTypeSlideoutOpen}
        onClose={() => setIsTypeSlideoutOpen(false)}
      />
      <EmailFormatSlideout
        isOpen={isFormatSlideoutOpen}
        onClose={() => setIsFormatSlideoutOpen(false)}
      />
    </div>
  );
}
